var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._t("default"),_c('div',{staticClass:"img_wrap"},[_c('a',{staticClass:"p img1",attrs:{"href":_vm.downloadUrl,"target":"_blank"}}),(_vm.androidDownloadUrl)?_c('a',{staticClass:"p img2",attrs:{"href":_vm.androidDownloadUrl,"target":"_blank"}}):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }